export const enableExtraWalletLogin = true;
export const devMode = false;
export const enableCustomLiquidityPrice = false; // liquidityprice=1
export const enableCardWithNoSupply = false; // nosupply=1
export const enableStar = true;
export const api_url = "https://api.skyweaverswap.com";
